import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {FinishProfile} from "../../product-details/interface/finish-profile";
import {FinishProfileItem} from "../../product-details/interface/finish-profile-item-list";
import {MatDialog} from "@angular/material/dialog";
import {
	ProductFinishProfileDialogComponent
} from "../product-finish-profile-dialog/product-finish-profile-dialog.component";

@Component({
	selector: 'fb-product-finish-profile',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-finish-profile.component.html',
	styleUrls: ['./product-finish-profile.component.scss']
})
export class ProductFinishProfileComponent implements OnChanges {

	@Input()
	public product: Product = {} as Product;
	@Input()
	public finishProfile: FinishProfile = {} as FinishProfile;

	public viewableFinishes: FinishProfileItem[] = [];
	public selectedFinishes: FinishProfileItem[] = [];

	@Output()
	public finishSelectionChange: EventEmitter<FinishProfileItem[]> = new EventEmitter<FinishProfileItem[]>();

	constructor(
		private _dialog: MatDialog
	) {
	}

	ngOnChanges(changes: SimpleChanges) {
		if(this.finishProfile.finishProfileItemList && this.finishProfile.finishProfileItemList.length > 6) {
			this.viewableFinishes = this.finishProfile.finishProfileItemList.slice(0,6);
		}
		else {
			this.viewableFinishes = this.finishProfile.finishProfileItemList;
		}
	}

	public toggleFinish(finish: FinishProfileItem): void {
		if(!this.selectedFinishes.includes(finish)) {
			this.selectedFinishes.push(finish);
			this.openFinishProfileDialog();
		}
		else {
			const index = this.selectedFinishes.indexOf(finish, 0);
			this.selectedFinishes.splice(index, 1);
		}
		this.finishSelectionChange.emit(this.selectedFinishes);
	}

	public openFinishProfileDialog(): void {
		const dialogRef = this._dialog.open(
			ProductFinishProfileDialogComponent,
			{
				id: 'finish-profile-dialog',
				data: {
					selectedFinishes: this.selectedFinishes,
					finishProfile: this.finishProfile
				},
				width: '100vw',
				maxWidth: '800px',
				maxHeight: '100vh',
				position: {
					top: '0',
					right: '0'
				}
			}
			);

		dialogRef.afterClosed().subscribe((result: FinishProfileItem[]) => {
			if(result) {
				this.selectedFinishes = result;
				this.finishSelectionChange.emit(this.selectedFinishes);
			}
		});
	}
}
